<template>
  <div id="ComponentInventoryCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="itemHeader">View PDC Stock</span>
          <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemList">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div id="ev_part_inventory_detail" class="admin-page-content asset-view list-view">
            <section class="internal-container border-top-table-fl">
              <div class="form-row no-divider">
                <div class="col-md-6">
                  <div v-if="isAdmin" class="row form-group">
                    <label class="col">Part :</label>
                    <span class="col">{{ titleCase(component_id.text) }}</span>
                  </div>
                  <div v-if="!isAdmin" class="row form-group">
                    <label class="col">Vendor Part Number:</label>
                    <span class="col">{{ titleCase(vendorPart.text) }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Purchase UOM:</label>
                    <template>
                      <span class="col">{{ titleCase(purchase_unit_id.text) }}</span>
                    </template>
                  </div>
                  <div class="row form-group">
                    <label class="col">Description:</label>
                    <template>
                      <span class="col">{{ titleCase(itemDescription) }}</span>
                    </template>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row form-group">
                    <label class="col">Amount Price 1 :</label>
                    <span class="col">{{ amount_price_one }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Order Multiple:</label>
                    <span class="col">{{ orderMultiple }}</span>
                  </div>
                  <div class="row form-group">
                    <label class="col">Quantity:</label>
                    <span class="col">{{ quantity }}</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import { contractMixins } from '../mixins/contractMixins';

Vue.component("loading-content", LoadingContent);

export default {
  name: "EvComponentInventoryView",
  components: {
    appFooter: () => import('@/components/Footer')
  },
  metaInfo() {
    return { title: (this.$route.params.id > 0) ? "View PDC Stock | " + process.env.COPYRIGHT_NAME : "View PDC Stock | " + process.env.COPYRIGHT_NAME }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    vendor_id: null,
    vendorArr: [],
    quantity: 0,
    location_id: null,
    locationArr: [],
    location_row: "",
    location_shelf: "",
    location_bin: "",
    loading: false,
    locationerrors: '',
    base_price: 0,
    base_price_error_msg: '',
    warehouse_id: '',
    warehouseerrors: '',
    component_id: '',
    component_error_msg: '',
    itemArr: [],
    warehouseArr: [],
    bill_item_Id: '',
    billItemArr: [],
    woCompArr: [],
    wo_comp_id: '',
    isComponentFilterable: true,
    rsbArr: [],
    rsb_id: '',
    onhand_min_qty: '',
    onhand_max_qty: '',
    selectedParts: [],
    rsb_iderror: '',
    stock_unit_id: null,
    stockunitArr: [],
    stockuniterrors: "",
    purchase_unit_id: null,
    purchaseuniterrors: "",
    purchaseunitArr: [],
    disableSMou: false,
    disableMou: false,
    is_default: false,
    is_fuel_product: false,
    qty_on_hand: null,
    qty_on_order: null,
    amount_price_one: null,
    bin: null,
    binArr: [],
    isAdmin: false,
    vendorPart: null,
    orderMultiple: "",
    itemDescription: "",
    velocity_env:process.env.NODE_ENV,
    // create a searchable dropdown for the bin.

  }),
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (self.velocity_env == "velev" || self.velocity_env == "velev_test") {
            if (element.name == 'ev_view_inventory') {
              self.cantAccessPage = true;
            }
          }else{
            if (element.name == 'add_component_transaction') {
              self.cantAccessPage = true;
            }
          }
        }
      }

    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    // console.log("Default " + self.expenseValue);
    self.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {

      self.loadItem();
      self.isComponentFilterable = false;
    } else {
      self.isComponentFilterable = true;
    }
    this.loadFieldData(['location', 'measurementUnit']);

    if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0) {
      //self.fetchInventory();
    } else {
      var userObj = JSON.parse(localStorage.getItem("user_obj"));
      if (userObj != null && userObj["location_id"] != null) {
        self.location_id = { value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")" };
      }
    }
    var userObj = JSON.parse(localStorage.getItem("user_obj"));
    if (userObj.roles[0].name == "admin") {
      self.isAdmin = true;
    } else {
      self.isAdmin = false;
    }
  },
  methods: {

    BackItemList() {
      var self = this;

      self.$router.push("/pdc-stock/list");

    },

    loadItem() {

      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/component-inventory/" + segments[3],
        type: "GET",
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          // console.log(data);
          if (data.status == "success") {

            if (data.content.itemId == null) {
              self.component_id = {value: "",text: ""};
            } else {
              self.component_id = { value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode + ")") };
            }
            self.selectedParts.push(self.component_id);

            if (data.content.location_id == null) {
              self.location_id = {value: "",text: ""};
            } else {
              self.location_id = { value: data.content.location_id, text: self.titleCase(data.content.locationName) + ' | ' + data.content.locCode };
            }

            if (data.content.stock_unit_id == null) {
              self.stock_unit_id = {value: "",text: ""};
            } else {
              self.stock_unit_id = { value: data.content.stock_unit_id, text: self.titleCase(data.content.mstUnitCode) + ' | ' + data.content.mstUnitName };
            }

            if (data.content.purchase_unit_id == null) {
              self.purchase_unit_id = {value: "",text: ""};
            } else {
              self.purchase_unit_id = { value: data.content.purchase_unit_id, text: self.titleCase(data.content.mUnitCode) + ' | ' + data.content.mUnitName };
            }

            if (data.content.onhand_min_qty == 0) {
              self.onhand_min_qty = "";
            } else {
              self.onhand_min_qty = data.content.onhand_min_qty;
            }
            if (data.content.onhand_max_qty == 0) {
              self.onhand_max_qty = "";
            } else {
              self.onhand_max_qty = data.content.onhand_max_qty;
            }

            self.qty_on_hand = data.content.quantity_on_hand;
            self.qty_on_order = data.content.quantity_on_order;
            self.amount_price_one = data.content.base_price;
            if (data.content.ev_part_bin_id != "" && data.content.ev_part_bin_id != null) {
              self.bin = { value: data.content.ev_part_bin_id, text: data.content.ev_bin }
            }else{
              self.bin = {value: "",text: ""};
            }

            if (!self.isAdmin) {
              var itemText = data.content.stock_part_number.concat("|", data.content.itemName);
              self.vendorPart = { value: data.content.itemId, text: data.content.vendorPart, item_text: itemText };
            }


            self.is_fuel_product = data.content.item_category_code === "FUEL" || data.content.item_category_code === "FUELNS";
            self.orderMultiple = data.content.order_multipler;
            self.quantity = data.content.quantity
            self.itemDescription = data.content.itemName;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'component-by-id')
        }
      });
    },

    isNumberKey: function (evt) {

      var self = this;

      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EvComponentInventoryView.vue